import { TranslateLoader } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';

import EN from '../../../assets/i18n/en.json';
import NL from '../../../assets/i18n/nl.json';
import ES from '../../../assets/i18n/es.json';
import FR from '../../../assets/i18n/fr.json';
import IT from '../../../assets/i18n/it.json';
import DE from '../../../assets/i18n/de.json';
import TR from '../../../assets/i18n/tr.json';
import RO from '../../../assets/i18n/ro.json';

@Injectable()
export class CustomLoader implements TranslateLoader {
    private langs: any = {
        en: EN,
        es: ES,
        nl: NL,
        fr: FR,
        it: IT,
        de: DE,
        tr: TR,
        ro: RO,
    };

    constructor(private httpClient: HttpClient) {

    }

    getTranslation(language: string) {
        return of(Object.assign({}, this.langs[language]));
    }
}
